import { TeamActionTypes, All } from '../actions/team.actions';
import { Team, RequestStatus } from '@app/shared';

// define State interface
export interface State {
  // is a user authenticated?
  selectedTeam: Team | null;
  // if authenticated, there should be a user object
  teams: Team[] | null;
  errorStatus: RequestStatus | null;
  successStatus: RequestStatus | null;
  isEditing: boolean | null;
  actionType: string | null;
}

// define initial state
export const initialState: State = {

  selectedTeam: null,
  teams: null,
  errorStatus: null,
  successStatus: null,
  isEditing:false,
  actionType:null,
};

export function reducer(state = initialState, action: All): State {
  switch (action.type) {
    case TeamActionTypes.GET_TEAMS_SUCCESS: {
      return {
        ...state,
        selectedTeam: null,
        teams: action.payload.teams,
        errorStatus:null,
        actionType:action.type,
      };
    }
    case TeamActionTypes.ADD_TEAM_MEMBER_SUCCESS:
    case TeamActionTypes.REMOVE_TEAM_MEMBER_SUCCESS:
    case TeamActionTypes.GET_TEAM_MEMBERS_SUCCESS: {
      return {
        ...state,
        // selectedTeam: null,
        // teams: action.payload.teams,
        selectedTeam: action.payload.team,
        successStatus:action.payload.successStatus,
        actionType:action.type,
        errorStatus:null,
      };
    }
    case TeamActionTypes.UPDATE_TEAM_SUCCESS: {
      return {
        ...state,
        selectedTeam: action.payload.team,
        successStatus:action.payload.successStatus,
        actionType:action.type,
        errorStatus:null,
      };
    }

    case TeamActionTypes.SET_TEAM: {
      return {
        ...state,
        selectedTeam: action.payload.team,
        actionType:action.type,
      };
    }
    case TeamActionTypes.CREATE_TEAM:
    case TeamActionTypes.EDIT_TEAM: {
      return {
        ...state,
        selectedTeam: action.payload.team,
        isEditing: action.payload.isEditing,
        actionType:action.type,
      };
    }
    case TeamActionTypes.UPDATE_TEAM_FAILURE:
    case TeamActionTypes.ADD_TEAM_MEMBER_FAILURE:
    case TeamActionTypes.REMOVE_TEAM_MEMBER_FAILURE:
    case TeamActionTypes.GET_TEAM_MEMBERS_FAILURE:
    case TeamActionTypes.SET_TEAM_FAILURE:
    case TeamActionTypes.GET_TEAMS_FAILURE: {
      return {
        ...state,
        errorStatus: action.payload.error.statusText,
        actionType:action.type,
      };
    }
    default: {
      return {
        ...state,
        actionType:null,
      };
    }
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/store/reducers/team.reducer.ts